module.exports = __webpack_public_path__ + "static/media/alarm.094450d0.svg";